<div class="text">
  <p>
    {{ 'RESOURCE_DELETE_WARNING' | translate: { displayName: displayName } }}
  </p>
</div>

<div class="button-container">
  <button
    mat-flat-button
    class="button"
    color="primary"
    (click)="deleteResource()"
  >
    {{ 'Yes' | translate }}
  </button>
  <button mat-flat-button class="button" color="primary" (click)="closeModal()">
    {{ 'No' | translate }}
  </button>
</div>

<br />

<hr />
